import Component from '../abstracts/Component';
import { trapFocusOnModal, removeTrapFocusOnModal } from "../utils/TrapFocus";


export default class PdpLayerComponent extends Component {
  get SELECTORS() {
    return {
      layerBox: '#pdp-layer-box',
      pdpMain: '[data-pdp-main]',
      layerTrigger: '[data-layer-trigger]',
      closeBtn: '[data-layer-close]',
      colorSwatches: '.c-pdp-c__color',
    };
  }

  get CLASSNAMES() {
    return {
      layerOpen: 'layer-open',
      open: 'open',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.trigger = document.querySelector(this.SELECTORS.layerTrigger);
    this.closeBtn = this.$component.querySelector(this.SELECTORS.closeBtn);
    this.layerBox = document.querySelector(this.SELECTORS.layerBox);
    this.pdpMain = document.querySelector(this.SELECTORS.pdpMain);
    this.accordion = document.querySelector('.c-pdp-accordion');
    this.colorSwatches = document.querySelectorAll(this.SELECTORS.colorSwatches);
    this.layerHeight = 0;
    this.layerIsOpen = false;
  }

  isMobile() {
    let mq = window.matchMedia('(max-width: 767px)');
    let isMobile = mq.matches;
    return isMobile;
  }

  setCustomVar() {
    this.layerHeight = this.$component.offsetHeight;
    let root = document.documentElement;
    root.style.setProperty('--js-pdp-layer-height', `${this.layerHeight}px`);
  }

  toggleLayer() {
    this.layerIsOpen
      ? this.$emit(this.$customEvents.PDP_LAYER_EVENTS.close)
      : this.$emit(this.$customEvents.PDP_LAYER_EVENTS.open);
  }

  //detects selected swatch for style
  selectColor() {
    let ctx = this;
    this.colorSwatches.forEach(function(swatch) {
      if(swatch.querySelector('a').dataset.productCode == ctx.pdpMain.dataset.productCode) {
        swatch.classList.add('selected-color');
      }
    });
  }

  // WE3-702 open layer always in viewport
  keepLayerOnScreen() {
    window.scroll({
      top: 30,
      behavior: 'smooth'
    });
  }

  bindEvents() {
    let trapFocusHandler = null;
    this.$on(this.$customEvents.PDP_LAYER_EVENTS.open, () => {
      this.keepLayerOnScreen();
      this.setCustomVar();
      this.layerIsOpen = true;
      trapFocusHandler = trapFocusOnModal(this.$component);
      this.$component.setAttribute("tabindex", "0");
      this.$component.focus();
      this.layerBox.classList.add(this.CLASSNAMES.layerOpen);
      this.pdpMain.classList.add(this.CLASSNAMES.layerOpen);
    });
    this.$on(this.$customEvents.PDP_LAYER_EVENTS.close, () => {
      this.layerIsOpen = false;
      removeTrapFocusOnModal(this.$component, trapFocusHandler);
      this.$component.setAttribute("tabindex", "-1");
      this.trigger.focus();
      this.layerBox.classList.remove(this.CLASSNAMES.layerOpen);
      this.pdpMain.classList.remove(this.CLASSNAMES.layerOpen);
    });
  }

  isDesktop(){
    return window.matchMedia('(min-width: 992px)').matches
  }

  listenEvents() {
    window.addEventListener('resize', () => this.setCustomVar());

    if(document.documentElement.getAttribute('data-whatintent') === 'keyboard') {
      this.trigger.addEventListener('focus', () => {
        this.isDesktop() && this.keepLayerOnScreen();
      });
    }

    this.trigger.addEventListener('click', (e) => {
      if (this.isMobile()) {
        this.accordion.scrollIntoView({ behavior: 'smooth', block: 'center' });
        let target = e.target.getAttribute('data-accordion-mobile');
        document.querySelector('[data-target="'+target+'"]').click();
      } else {
        this.toggleLayer();
      }
    });
    this.trigger.setAttribute('aria-expanded', this.layerIsOpen);

    this.closeBtn.addEventListener('click', () => {
      this.$emit(this.$customEvents.PDP_LAYER_EVENTS.close);
    });
  }

  render() {
    this.log('Rendering...');
    // this.setCustomVar();
    this.bindEvents();
    this.selectColor();
    window.onload = () => {
      this.listenEvents()
    };
  }
}
